// =========================================================================
// service_api_prombook_catalog.js
// server_api_v1 의 prombook 클라용 API 카탈로그 (재편본 2026-08-04 기준 재작업).
//
//   ⚠️ /api/v1 프리픽스 없음. koa auto-router 가 routes/**/*.js 를 그대로 URL 로 등록.
//     - prombook 전용   → /prombook/<경로>
//     - 공용(재사용)     → 루트 (/auth/*, /userinfo/*, /userdata/*, /mail/*, /cash/*, /shop/*)
//     - 오퍼월 콜백      → /pub/prombook/*  (인증 X)
//     - 이미지 업로드    → /s3_image_upload (별도 라우터, ApiTester 업로드 패널에서 사용)
//
//   출처: routes/prombook/_PROMBOOK_API_LIST.md
//   ※ 활성 23개는 아직 스켈레톤(NOT_IMPLEMENTED)일 수 있음 — 경로 확인/테스트용.
//   base URL 은 어드민이 ApiTester 에서 직접 입력 (localhost / dev / live).
// =========================================================================

export const SERVICE_API_PROMBOOK_CATALOG = [
  {
    // 공용 로그인/계정 — 루트 /auth/*. 로그인은 no-auth, 나머지는 토큰 필요.
    // 디바이스 정보(device_uuid/device_type/package)는 서버가 헤더에서 읽음(미전송 시 UNKNOWN 기본).
    group: 'Auth (공용)',
    apis: [
      { name: 'sa_auth_login',  label: '로그인',            endpoint: '/auth/login',  auth: false,
        defaults: { LOGIN_TYPE: 'guest', AUTH_ID: 'TEST_USER', AD_ID: '', IDFV_ID: '' } },
      { name: 'sa_auth_delete', label: '로그아웃/토큰제거',  endpoint: '/auth/delete', auth: true,
        defaults: {} },
    ],
  },
  {
    // 리스트 — 엔드포인트 하나(/prombook/prompts/list) + sort 로 모드 선택.
    //   recent | popular | demo | liked | mine(=MyPrompts)
    group: 'Prompts · 리스트',
    apis: [
      { name: 'sa_prompts_list',       label: '리스트(최신)',      endpoint: '/prombook/prompts/list', auth: true,
        defaults: { sort: 'recent', limit: 100, cursor: null } },
      { name: 'sa_prompts_list_pop',   label: '리스트(인기)',      endpoint: '/prombook/prompts/list', auth: true,
        defaults: { sort: 'popular', limit: 100, cursor: null } },
      // demo = 성별·연령 복사수 랭킹. gender: a(종합)/m/f, age: 0(전연령)/10/20/30/40/50
      { name: 'sa_prompts_list_demo',  label: '리스트(성별·연령)', endpoint: '/prombook/prompts/list', auth: true,
        defaults: { sort: 'demo', gender: 'm', age: 20, limit: 100, cursor: null } },
      // liked = 내가 좋아요한 프롬프트만
      { name: 'sa_prompts_list_liked', label: '리스트(좋아요)',    endpoint: '/prombook/prompts/list', auth: true,
        defaults: { sort: 'liked', limit: 100, cursor: null } },
      // mine = 내가 등록한 프롬프트(구 /prompts/mine 대체 = MyPrompts)
      { name: 'sa_prompts_list_mine',  label: '리스트(내가 등록)', endpoint: '/prombook/prompts/list', auth: true,
        defaults: { sort: 'mine', limit: 100, cursor: null } },
    ],
  },
  {
    group: 'Prompts',
    apis: [
      { name: 'sa_prompts_search', label: '검색',        endpoint: '/prombook/prompts/search', auth: true,
        defaults: { keyword: '테스트', limit: 100, cursor: null } },
      { name: 'sa_prompts_create', label: '등록',        endpoint: '/prombook/prompts/create', auth: true,
        defaults: { author_type: 'user', prompt_type: 'image', title: '클라 테스트', body: '본문', thumb_path: '', images: ['https://cdn.snapplay.io/prombook/prompts/sample1.jpg', 'https://cdn.snapplay.io/prombook/prompts/sample2.jpg'], tags: ['test'] } },
      { name: 'sa_prompts_detail', label: '상세',        endpoint: '/prombook/prompts/detail', auth: true,
        defaults: { id: 1 } },
      { name: 'sa_prompts_like',   label: '좋아요 토글', endpoint: '/prombook/prompts/like',   auth: true,
        defaults: { id: 1 } },
      { name: 'sa_prompts_report', label: '신고',        endpoint: '/prombook/prompts/report', auth: true,
        defaults: { id: 1, reason_code: 'spam', reason_text: '' } },
      { name: 'sa_prompts_copy',   label: '복사하기',    endpoint: '/prombook/prompts/copy',   auth: true,
        defaults: { id: 1 } },
    ],
  },
  {
    group: 'Feeds',
    apis: [
      { name: 'sa_feeds_create', label: '피드 등록',   endpoint: '/prombook/feeds/create', auth: true,
        defaults: { title: '테스트 피드', body: '본문', images: ['https://cdn.snapplay.io/prombook/feeds/sample1.jpg', 'https://cdn.snapplay.io/prombook/feeds/sample2.jpg'] } },
      { name: 'sa_feeds_list',   label: '피드 리스트', endpoint: '/prombook/feeds/list',   auth: true,
        defaults: { limit: 100, cursor: null } },
      { name: 'sa_feeds_detail', label: '피드 상세',   endpoint: '/prombook/feeds/detail', auth: true,
        defaults: { id: 1 } },
      { name: 'sa_feeds_like',   label: '피드 좋아요', endpoint: '/prombook/feeds/like',   auth: true,
        defaults: { id: 1 } },
      { name: 'sa_feeds_report', label: '피드 신고',   endpoint: '/prombook/feeds/report', auth: true,
        defaults: { id: 1, reason_code: 'spam', reason_text: '' } },
    ],
  },
  {
    group: 'Comments',
    apis: [
      { name: 'sa_comments_list',   label: '댓글 리스트',  endpoint: '/prombook/feeds/comments/list',   auth: true,
        defaults: { feed_id: 1, limit: 20, cursor: null } },
      { name: 'sa_comments_create', label: '댓글/대댓글', endpoint: '/prombook/feeds/comments/create', auth: true,
        defaults: { feed_id: 1, parent_id: null, body: '댓글 테스트' } },
      { name: 'sa_comments_delete', label: '댓글 삭제',    endpoint: '/prombook/feeds/comments/delete', auth: true,
        defaults: { id: 1 } },
      { name: 'sa_comments_like',   label: '댓글 좋아요',  endpoint: '/prombook/feeds/comments/like',   auth: true,
        defaults: { id: 1 } },
      { name: 'sa_comments_report', label: '댓글 신고',    endpoint: '/prombook/feeds/comments/report', auth: true,
        defaults: { id: 1, reason_code: 'spam', reason_text: '' } },
    ],
  },
  {
    // 활동알림(PROMBOOK_ACTIVITY_LOG). unread_count 는 multiple_fetch_data(NotiUnreadCount)로 흡수됨.
    group: 'Notifications',
    apis: [
      { name: 'sa_notifications_list', label: '알림 리스트',    endpoint: '/prombook/notifications/list', auth: true,
        defaults: { limit: 20, cursor: null } },
      { name: 'sa_notifications_read', label: '알림 읽음 처리', endpoint: '/prombook/notifications/read', auth: true,
        defaults: { ids: [1, 2, 3] } },
    ],
  },
  {
    // 소셜 차단(PROMBOOK_USER_BLOCK). block_list 는 multiple_fetch_data(BlockList)로 흡수됨.
    group: 'User · 차단',
    apis: [
      { name: 'sa_user_block',   label: '유저 차단',      endpoint: '/prombook/user/block',   auth: true,
        defaults: { user_id: 'TARGET_ID' } },
      { name: 'sa_user_unblock', label: '유저 차단 해제', endpoint: '/prombook/user/unblock', auth: true,
        defaults: { user_id: 'TARGET_ID' } },
    ],
  },
  {
    // 공용 계정/유저정보 — 루트 /userinfo/*
    group: '계정/유저정보 (공용)',
    apis: [
      { name: 'sa_userinfo_get',           label: '내 정보 조회',        endpoint: '/userinfo/get_user_info',           auth: true,
        defaults: {} },
      { name: 'sa_userinfo_regist_nick',   label: '닉네임 변경',         endpoint: '/userinfo/regist_nick',             auth: true,
        defaults: { nick_name: 'tester' } },
      { name: 'sa_userinfo_thumb',         label: '썸네일 변경',         endpoint: '/userinfo/update_user_thumb',       auth: true,
        defaults: { thumb_path: '' } },
      { name: 'sa_userinfo_sexage',        label: '성별/나이 설정',      endpoint: '/userinfo/set_userinfo_sexage',     auth: true,
        defaults: { sex: 'm', age: 20 } },
      { name: 'sa_userinfo_delete',        label: '계정 탈퇴',           endpoint: '/userinfo/delete_user_account',     auth: true,
        defaults: {} },
      { name: 'sa_userinfo_phone_request', label: '핸드폰 인증 요청(키 발급)', endpoint: '/userinfo/create_phone_verify_code', auth: true,
        defaults: {} },
      { name: 'sa_userinfo_phone_verify',  label: '핸드폰 인증 확인',    endpoint: '/userinfo/check_user_phone_verify', auth: true,
        defaults: {} },
    ],
  },
  {
    // 공용 유저데이터 — 루트 /userdata/*
    group: '유저데이터 (공용)',
    apis: [
      { name: 'sa_userdata_load',       label: 'user_data load',   endpoint: '/userdata/load_data',       auth: true,
        defaults: {} },
      { name: 'sa_userdata_save',       label: 'user_data save',   endpoint: '/userdata/save_data',       auth: true,
        defaults: { data: { foo: 'bar' } } },
      { name: 'sa_userdata_push_token', label: '푸시 토큰 등록',   endpoint: '/userdata/save_push_token', auth: true,
        defaults: { push_token: 'TEST_FCM_TOKEN' } },
      { name: 'sa_userdata_push_data',  label: '푸시 설정 갱신',   endpoint: '/userdata/save_push_data',  auth: true,
        defaults: { key: 'like', value: 'N' } },
    ],
  },
  {
    // 공용 우편 — 루트 /mail/*
    group: 'Mail (공용)',
    apis: [
      { name: 'sa_mail_load', label: '우편 목록',       endpoint: '/mail/mail_load', auth: true,
        defaults: {} },
      { name: 'sa_mail_read', label: '우편 수령(읽기)', endpoint: '/mail/mail_read', auth: true,
        defaults: { mail_id: 1 } },
    ],
  },
  {
    // 공용 상점/구매 — /shop/*, /cash/*
    group: '상점/구매 (공용)',
    apis: [
      { name: 'sa_shop_product_list', label: '상품 목록',   endpoint: '/shop/get_product_coin_list', auth: true,
        defaults: {} },
      { name: 'sa_cash_buy_product',  label: '상품 구매',   endpoint: '/cash/buy_shop_product',      auth: true,
        defaults: { prd_id: 1001 } },
      { name: 'sa_cash_buy_list',     label: '내 구매내역', endpoint: '/cash/get_buy_product_list',  auth: true,
        defaults: { limit: 20 } },
      { name: 'sa_cash_buy_state',    label: '쿠폰 상태 변경', endpoint: '/cash/set_buy_product_state', auth: true,
        defaults: { tr_id: '' } },
    ],
  },
  {
    // getter 통합 진입점 — /prombook/multiple_fetch_data(_keys)
    // FETCH_KEYS: UserInfo · PointInfo · MailList · NotiUnreadCount · BlockList · PushState · MainFeatured · MyPrompts · MyFeeds
    group: 'MultipleFetchData',
    apis: [
      { name: 'sa_multi_fetch',      label: '다중 페치 호출',       endpoint: '/prombook/multiple_fetch_data',      auth: true,
        defaults: { FETCH_KEYS: ['UserInfo', 'PointInfo', 'MailList', 'NotiUnreadCount', 'MainFeatured'] } },
      // 메인 피처 리스트 — MainFeatured fetcher (slot: main|recommend|weekly|new_image|hot, limit ≤ 100)
      { name: 'sa_main_featured',    label: '메인 피처 리스트(슬롯)', endpoint: '/prombook/multiple_fetch_data',      auth: true,
        defaults: { FETCH_KEYS: ['MainFeatured'], slot: 'main', limit: 30 } },
      // 3일 급상승(핫) TOP10 — slot='hot'
      { name: 'sa_hot_list',         label: '급상승 핫(slot=hot)',   endpoint: '/prombook/multiple_fetch_data',      auth: true,
        defaults: { FETCH_KEYS: ['MainFeatured'], slot: 'hot', limit: 10 } },
      { name: 'sa_multi_fetch_keys', label: '지원 KEY 목록',        endpoint: '/prombook/multiple_fetch_data_keys', auth: false,
        defaults: {} },
    ],
  },
  {
    // 오퍼월 콜백 — /pub/prombook/* (인증 X, 시그니처 검증). 수동 테스트 의미 적어 기본 숨김 그룹.
    group: 'Offerwall (pub · 시그니처 필요)',
    apis: [
      { name: 'sa_offerwall_adjoe',    label: 'adjoe receive',    endpoint: '/pub/prombook/offerwall_receive_adjoe',    auth: false,
        defaults: { user_uuid: 'TEST_USER', trans_uuid: 'TEST_TX', coin_amount: 100, sid: '', currency: 'KRW' } },
      { name: 'sa_offerwall_snapplay', label: 'snapplay receive', endpoint: '/pub/prombook/offerwall_receive_snapplay', auth: false,
        defaults: { tr_id: 'TEST_TR', pub_user_nm: 'TEST_USER', user_pnt: 100, check_cd: 'PASTE_SHA256_HEX' } },
      { name: 'sa_offerwall_cpx',      label: 'cpx receive',      endpoint: '/pub/prombook/offerwall_receive_cpx',      auth: false,
        defaults: { trans_id: 'TEST_TX', user_id: 'TEST_USER', amount_local: 100, status: 1, os_type: 'android', hash: '' } },
    ],
  },
]
